import React, { Component } from 'react';
import "./oversizedSideBySideImages.css";

export default class extends Component {
  constructor(props) {
      super(props);
      this.state = {
          componentReady: 'ready'
      };
  }

  render() {
    return (
      <div className={`row ${ this.props.direction }`}>
        <div className="small-12 medium-6">
          <div className="oversized-side-by-side-image-one">
            <img className="full-width background-image-fill hover-grow" src={"images/square.png"} style={{backgroundImage: `url(${ this.props.imageOne })`}} />
          </div>
        </div>
        <div className="small-12 medium-6">
          <div className="oversized-side-by-side-image-two row">
            <div className="full-width background-image-fill hover-grow" style={{backgroundImage: `url(${ this.props.imageTwo })`}} ></div>
            <img className="full-width show-for-small" src={"images/square.png"} />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/alpineComponents/oversizedSideBySideImages/index.js